import { useAuthStore } from '@sparkai/auth'
import { UserRoles } from '@sparkai/shared-types'
import { AppsPaths, getAppPort } from '@sparkai/utils'
import { jwtDecode } from 'jwt-decode'
import { useEffect, useMemo, useRef } from 'react'
import { useLocation } from 'react-router-dom-v5-compat'

export function Redirector() {
  const token = useAuthStore((state) => state.token)
  const location = useLocation()

  const decodedToken = useMemo(() => {
    return (token ? jwtDecode(token) : {}) as Record<string, string>
  }, [token])

  const hasRedirected = useRef(false)

  useEffect(() => {
    if (!decodedToken || hasRedirected.current) return
    const returnTo = location.state?.returnTo

    if (returnTo) {
      const redirectUrl = buildRedirectUrl('/web/', returnTo)
      window.location.href = redirectUrl
      hasRedirected.current = true

      return
    }

    const role = decodedToken['https://spark.ai/sparkai-role']
    const redirectUrl = getRedirectUrlByRole(role as UserRoles)

    window.location.href = redirectUrl
    hasRedirected.current = true
  }, [decodedToken, location.state?.returnTo])

  return (
    <div className='flex h-screen w-full flex-col items-center justify-center bg-brand-gray-50 text-sm text-brand-gray-400'>
      Loading...
    </div>
  )
}

const buildRedirectUrl = (path: AppsPaths, returnTo?: string) => {
  const parsedReturnTo = returnTo ? returnTo.replace(/^\//, '') : ''
  if (import.meta.env.DEV && location.hostname !== 'spark.local') {
    const origin = `${window.location.protocol}//${window.location.hostname}`

    const url = `${origin}:${getAppPort(path)}${path}${parsedReturnTo}`
    return url
  }

  return `${window.location.origin}${path}${parsedReturnTo}`
}

const getRedirectUrlByRole = (role: UserRoles) => {
  switch (role) {
    case 'admin':
      return buildRedirectUrl('/admin/')
    case 'applicant':
    case 'operator':
    case 'trainee':
      return buildRedirectUrl('/ms/')
    case 'customer':
    case 'account_owner':
      return buildRedirectUrl('/customer/')
    default:
      return buildRedirectUrl('/web/')
  }
}
